export const API_ORGANIZATIONS_ORGANIZATIONID_CONTENT_RATINGS_PATH_KEY =
  '/organizations/{organizationId}/content-ratings';
export const API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_RATINGS_PATH_KEY =
  '/organizations/{organizationId}/user/content-ratings';
export const API_CONTENTS_CONTENTID_CONTENT_RATINGS_STATISTICS_PATH_KEY =
  '/contents/{contentId}/content-ratings/statistics';
